import { BUSCAR_AGENCIAS_EMPRESA } from '../../actions/types'

export default function reducerAgenciasEmpresa (state = [], action) {
  switch (action.type) {
    case BUSCAR_AGENCIAS_EMPRESA: {
      const agencias = action.payload.data;

      if (agencias) {
        return agencias
      }
      return []
    }

    default: {
      return state
    }
  }
}
